<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('CLASS_MODE.TITLE') }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t('CLASS_MODE.DESCRIPTION') }}
        </p>
        <p>
          {{ $t('CLASS_MODE.HOW_TO_JOIN') }}
        </p>
        <div>
          <v-text-field
            :label="$t('CLASS_MODE.CODE')"
            v-model="code"
            outlined
          ></v-text-field>
        </div>

        <div class="text-center">
          <span>{{ $t('CLASS_MODE.IF_TEACHER') }}</span>
          <v-btn
            small
            text
            @click="createRoom()"
          >
            {{ $t('CLASS_MODE.CREATE_ROOM') }}
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('BACK') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="access"
        >
          {{ $t('CLASS_MODE.ACCESS') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClassModeModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    code: '',
  }),
  methods: {
    close() {
      this.$emit('input', false);
    },
    createRoom() {
      this.$store.dispatch('classMode/create')
        .then(() => {
          this.$store.dispatch('alerts/show', {
            text: 'Estás en modo clase',
          });
          if (this.$route.name !== 'home') {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$store.dispatch('alerts/show', {
            text: 'Algo ha salido mal...',
          });
        });

      this.$track('class_mode_create', this.$route.name);
    },
    access() {
      this.$emit('input', false);
      this.$store.dispatch('classMode/enable', this.code)
        .then(() => {
          this.$store.dispatch('alerts/show', {
            text: 'Estás en modo clase',
          });
          if (this.$route.name !== 'home') {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$store.dispatch('alerts/show', {
            text: 'Parece que ese grupo no existe',
          });
        });

      this.$track('class_mode_join', this.$route.name);
    },
  },
};
</script>
